"use client";

import Image from "next/image";
import { cn } from "@/utils/utils";

/**
 * 咕咕 — rendered directly from the approved hand-drawn artwork
 * (public/gugu/gugu.png, transparent background). No redrawn SVG shapes, so
 * the face and feathers stay exactly the soft original. The gentle nod +
 * occasional wink are applied as CSS transforms on the image itself.
 * Reused across every space, the chat tree hollow, and settings.
 */
export function GuguBird({
  size = 44,
  className,
  nod = true,
}: {
  size?: number;
  className?: string;
  nod?: boolean;
}) {
  return (
    <span
      className={cn("relative inline-block align-middle", className)}
      style={{ width: size, height: size }}
      aria-label="咕咕"
      data-eazo-component="gugu-bird"
    >
      <Image
        src="/gugu/gugu.png"
        alt="咕咕"
        width={size}
        height={size}
        className={cn("h-full w-full object-contain", nod && "wsm-bird-wink")}
        draggable={false}
      />
    </span>
  );
}
